import { useState, useEffect } from "react";
import axios from "axios";
import configData from "../config.json";
import { Link } from "react-router-dom";
import { useRef } from "react";

const Reviews = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(5);
  const [review, setReview] = useState("");
  const [name, setName] = useState("");
  const emailRef = useRef(null);

  const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Load reviews
  useEffect(() => {
    fetchReviews();
  }, [productId]);

  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${configData.SERVER_URL}/reviews/${productId}`);
      setReviews(res.data);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  // Submit review
  const submitReview = async () => {
    if (!name || !isValidEmail(name.trim())) {
    alert("Please enter a valid email");
    emailRef.current.focus();
    return;
    }
    if (!review) return alert("Write a review");
    try {
      const res = await axios.post(`${configData.SERVER_URL}/reviews`, {
      ProductID: productId,
      user_name: name || "Anonymous",
      rating,
      review,
      });
      if(res.data.success){
        setReview("");
        setRating(5);
        fetchReviews();
      } else {alert(res.data.message)}
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };


  return (
    <div className="mt-5">

      {/* ⭐ Submit Review */}
      <div className="card p-3 mb-4">
        <h5>Write a Review</h5>

        <input
          type="email"
          className="form-control mb-2"
          placeholder="email"
          ref={emailRef}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <div className="my-3">
        <p><Link to="/register" ><i className="fa fa-user-plus mr-1"></i>Register</Link> </p>
        </div>

        <select
          className="form-select mb-2"
          value={rating}
          onChange={(e) => setRating(Number(e.target.value))}
        >
          {[5, 4, 3, 2, 1].map((r) => (
            <option key={r} value={r}>
              {r} ⭐
            </option>
          ))}
        </select>

        <textarea
          className="form-control mb-2"
          placeholder="Write your review..."
          value={review}
          onChange={(e) => setReview(e.target.value)}
        />

        <button className="btn btn-success" onClick={submitReview}>
          Submit Review
        </button>
      </div>

      {/* ⭐ Review List */}
      <h5>Customer Reviews</h5>

      {reviews.length === 0 ? (
        <p className="text-muted">No reviews yet</p>
      ) : (
        reviews.map((r) => (
          <div key={r.id} className="border p-2 mb-2 rounded">

            <strong>{r.user_name}</strong>

            <div className="text-warning">
              {"★".repeat(r.rating)}
              {"☆".repeat(5 - r.rating)}
            </div>

            <p className="mb-0">{r.review}</p>
          </div>
        ))
      )}
    </div>
  );
};

export default Reviews;